<template>
	<div class="cb-notification" :style="info && backgroundColor" :class="[{'cb-notification__warning' : type == 'warning'},{'cb-notification__soft-warning' : type == 'soft_warning'}]">
		<div class="cb-notification__icon">
			<i class="icon-info-circle"></i>
		</div>
		<div class="cb-notification__content">
			<slot></slot>
		</div>
	</div>
</template>
<script type="text/javascript">
export default {
	props: ['type'],
	computed: {
		info(){
			return this.type != 'warning' && this.type != 'soft_warning'
		}
	}
}
</script>


// WEBPACK FOOTER //
// Notification.vue?5d6bfc84